<h2>{{ assessment.title }}</h2>
<div>{{ assessment.uref }}</div>
<div>{{ assessment.description }}</div>
<div class="d-none">{{ assessment.email }}</div>

<div>&nbsp;</div>

<div *ngFor="let section of sections" >
    <h4>{{ section.id }} {{ section.title }}</h4>
    <div [innerHtml]="section.description"></div>
    <div *ngFor='let r of reports'>
      <div *ngIf="section.id === r.section_id">
        <app-report [report]="r"></app-report>
      </div>
    </div>
</div>
<h2 class="d-none" [innerHTML]="roughcheck.title"></h2>
<div class="d-none" [innerHTML]="roughcheck.description"></div>
<div class="row">
<div class="col-sm-2" i18n="Sponsored by">LABEL_SPONSORED_BY</div>
<div class="col-sm-10"><a
  [href]="roughcheck.website"
  target="_blank">
  <span [innerHTML]="roughcheck.sponsor"></span>
  <span class="fas fa-external-link-alt ml-1"></span></a>
</div>
</div>

<div>&nbsp;</div>
<button
  (click)="goNext()"
  class="btn btn-primary float-end"
  i18n="Next">BUTTON_NEXT</button>
<button
  (click)="goPrevious()"
  class="btn btn-secondary"
  i18n="Previous">BUTTON_PREVIOUS</button>
